import React, { memo } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { snakeCase } from "lodash";
import { countryCodes } from "../../consts";
import { TiCardActor } from "../../../../@types";

interface Props {
  actors: Array<TiCardActor>;
  onActorClick?: (actor: TiCardActor) => void;
}

const TiCardActors = ({ actors, onActorClick }: Props) => (
  <>
    {actors.map((actor, index) => (
      <span key={`actor_${actor.name}`} onClick={() => onActorClick?.(actor)}>
        {actor.country.length > 0 && countryCodes[actor.country] && (
          <OverlayTrigger
            overlay={
              <Tooltip
                data-testid={`ticard_information_row_actor_${snakeCase(
                  actor.name
                )}_flag`}
              >
                {actor.country}
              </Tooltip>
            }
            placement="top"
          >
            <span className={`flag flag-${countryCodes[actor.country]}`} />
          </OverlayTrigger>
        )}
        {actor.aliases.length > 0 && (
          <OverlayTrigger
            overlay={
              <Tooltip
                data-testid={`ticard_information_row_actor_${snakeCase(
                  actor.name
                )}_aliases`}
              >
                {actor.aliases.join(", ")}
              </Tooltip>
            }
            placement="top"
          >
            <p
              className={"ticard-content__information-row__link"}
              data-testid={`ticard_information_row_actor_${snakeCase(
                actor.name
              )}_link`}
            >
              {actor.name}
            </p>
          </OverlayTrigger>
        )}
        {actor.aliases.length === 0 && (
          <p
            className={"ticard-content__information-row__link"}
            data-testid={`ticard_information_row_actor_${snakeCase(
              actor.name
            )}_link`}
          >
            {actor.name}
          </p>
        )}
        {index < actors.length - 1 ? ", " : ""}
      </span>
    ))}
  </>
);

export default memo(TiCardActors);
